import { Component, Inject, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DialogDataWithTemplate {
  header: string;
  form?: FormGroup;
  /** if yesText falsy, no button appears */
  yesText: string;
  /** if noText falsy, no button appears */
  noText: string;
  isAffirmativeWarnColor?: boolean; //warn-flat
  /** content shouldn't be set if template is passed in */
  content: string;
  /** ignored if isAffirmativeWarnColor is true */
  isAffirmativeBasicColor?: boolean; //basic stroked
  /** ignored if isAffirmativeBasic is true or isAffirmativeBasicColor is true   */
  isAffirmativeBasic?: boolean;
  template?: TemplateRef<any>;
  extraButtons?: TemplateRef<any>;
  hideButtonBar?: boolean;
  /** a function that is called when clicking okay. If returns true, closes modal */
  onOkay: () => Promise<boolean>;
}

@Component({
  selector: 'dialog-lib',
  templateUrl: 'dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: false
})
export class DialogComponent {
  //default is color 'primary' variant 'flat'
  primaryColor: 'warn' | 'primary' | 'basic' = 'primary';
  primaryButtonVariant: 'basic' | 'raised' | 'flat' | 'stroked' = 'flat';

  constructor(
    public dialogRef: MatDialogRef<DialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA)
    public data: DialogDataWithTemplate
  ) {
    if (data.isAffirmativeWarnColor) {
      this.primaryColor = 'warn';
    } else if (data.isAffirmativeBasicColor) {
      this.primaryColor = 'basic';
      this.primaryButtonVariant = 'stroked';
    } else if (data.isAffirmativeBasic) {
      this.primaryColor = 'basic';
      this.primaryButtonVariant = 'basic';
    }
  }

  clickClose = async (isSave: boolean): Promise<boolean> => {
    if (isSave === true) {
      if (this.data.form?.invalid) {
        this.data.form.markAllAsTouched();
        return false;
      }
      if (this.data.onOkay) {
        const isSuccess = await this.getOnOkayResult();
        if (isSuccess) {
          this.dialogRef.close(isSave);
        }
        return isSuccess;
      }
    }

    this.dialogRef.close(isSave);
    return true;
  };
  private getOnOkayResult = async (): Promise<boolean> => {
    try {
      return await this.data.onOkay();
    } catch (e) {
      console.error(`error in onOkayPromise. closing modal`, e);
      this.dialogRef.close(false);
      return false;
    }
  };
}
